import { ICellRendererParams } from "ag-grid-community";
import _ from "lodash";
import { TranslateService } from "projects/shared/src/lib/services/translate.service";


export class AgGridProjectRoleTemplatesSettings {

  private isAdminSign: string = '';
  private params : any;


  constructor(private translate: TranslateService, private isAdminTemplate: boolean = true) { 
    console.log("=========> isAdminTemplate: ", this.isAdminTemplate);
    this.isAdminSign = this.isAdminTemplate ? '✔️' : '';
    // Call agInit from constructor with a default or empty params object
    this.agInit({} as ICellRendererParams);
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    console.log("=========> agInit params: ", this.params);
    //console.log("=========> agInit params: name = ", this.params.data.name);
    // this.valueConfPageDto = params.data;
    // this.icon_edit = this.params.icon_edit || null;
    // this.icon_delete = this.params.icon_delete || null;
    // this.vcfpComponent = params.context.vcfpComponent;
    // this.refresh(params);
  }

  public agGridProjectRoleTemplatesSettings = {
    rowModelType: 'infinite',
    rowSelection: 'single',
    rowHeight: 55,
    enableRangeSelection: true,
    cacheBlockSize: 1000,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 1,
    paginationPageSize: 30,
    infiniteInitialRowCount: 0,
    columnDefs: [
      { field: 'name', headerName: "Name der Vorlage", cellStyle: { color: '#303f6f' }, sortable: true, filter: true },
      { 
        headerName: "Admin Vorlage", 
        cellStyle: { color: '#303f6f' }, 
        sortable: true, 
        filter: true,
        cellRenderer: (params: any) => {
          if (params.data && params.data.isforadmin === true) {
            // return `<span style="color: #303f6f; font-size: 18px;">✔️</span>`;
            return `<span style="color: #003366; font-size: 18px;">&check;</span>`;
          }
          return '';
        }
      },
      {
        headerName: `${this.translate.data["TENANTGROUPROLESACTIONSCOLUMNHEADER"]}`,
        cellStyle: { color: '#303f6f' },
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          icon_edit: 'edit',
          icon_delete: 'delete',
          icon_view: 'visibility',
        }
      },
    ],
    defaultColDef: {
      flex: 1,
      resizable: true,
      minWidth: 100,
      editable: false
    }
  }
}